import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose, onSuccess }) => {
  const [activeTab, setActiveTab] = useState('register');
  const { t } = useTranslation();

   if (!isOpen) {
    return null;
  }

  // DEĞİKLİK 1: Modal'ı kapatma fonksiyonu, `onSuccess` ile aynı işi yapacak.
  // Bu, hem "Login" hem de "Register" formlarından sonra modalın kapanmasını sağlar.
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    onClose(); // Her durumda modalı kapat
  };

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="auth-tabs">
          <button 
            className={`auth-tab-btn ${activeTab === 'register' ? 'active' : ''}`}
            onClick={() => setActiveTab('register')}
          >
            {t('new_user')}
          </button>
          <button 
            className={`auth-tab-btn ${activeTab === 'login' ? 'active' : ''}`}
            onClick={() => setActiveTab('login')}
          >
            {t('existing_member')}
          </button>
        </div>

        <div className="auth-form-container">
          {activeTab === 'login' ? (
            <LoginForm onSuccess={onSuccess} /> // Bu, modalı kapatır
          ) : (
            // DÜZELTME: RegisterForm başarılı olduğunda, artık sadece modalı kapatacak 'onSuccess'ı çağırır.
            // Otomatik giriş işlemini kendi içinde zaten yaptı.
            <RegisterForm onSuccess={onSuccess} idPrefix="modal-" />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;